import { render, staticRenderFns } from "./text-component.vue?vue&type=template&id=56463df6&scoped=true"
import script from "./text-component.vue?vue&type=script&lang=js"
export * from "./text-component.vue?vue&type=script&lang=js"
import style0 from "./text-component.vue?vue&type=style&index=0&id=56463df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56463df6",
  null
  
)

export default component.exports